import React from "react";

import { Link } from "react-router-dom";

import Chrome from "../components/Chrome";
import { planUploadURL } from "../urls";
import BodyText from "Cobalt/BodyText";
import { LinkButton } from "Cobalt/Button";
import { CardSection } from "Cobalt/Card";
import { H4 } from "Cobalt/Header";
import { Row, Col } from "Common/Grid";
import Icon from "Common/Icon";

const DonePage = () => (
  <Chrome title="Partner Broker Done">
    <CardSection>
      <Link component={LinkButton} size="medium" to={planUploadURL} color="link" pl={0} mb={3}>
        <Icon icon="chevron-left" pr={3} />
        Back
      </Link>
      <Row mb={5}>
        <Col>
          <H4>That&rsquo;s All For Now</H4>
          <BodyText mt={4}>
            You have created your account and uploaded any additional plan files. We will reach out to you when the implementation period is complete. This
            process typically takes 3-4 weeks.
          </BodyText>
        </Col>
      </Row>
    </CardSection>
  </Chrome>
);

export default DonePage;
